import React from "react";
import chorus_name_logo from "../assets/logo_icon_name.png";
import "./Footer.scss";
import { useLocation } from "react-router-dom";

const Footer = () => {
  const location = useLocation();
  return (
    <>
      {" "}
      {!location.pathname.includes("preprints") && (
        <footer className="footer ">
          <hr />

          {/* Footer Links */}
          <div className="container-fluid">
            <div className="footer-content text-start row gap-4 ">
              {/* Logo + tagline */}
              <div className="footer-brand col-12 col-lg-3 text-center">
                <img
                  src={chorus_name_logo}
                  alt="CHORUS logo and name"
                  className="brand-logo my-3"
                />
                <p>Making Open Research Work</p>
              </div>

              {/* Company */}
              <div className="col text-center text-lg-start ps-4">
                <h4>Company</h4>
                <ul className="list-unstyled d-flex flex-column gap-2 text-center text-lg-start">
                  <li>
                    <a
                      href="https://www.chorusaccess.org/about/about-chorus/"
                      target="_blank"
                      className="text-decoration-none"
                    >
                      About
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.chorusaccess.org/services/"
                      target="_blank"
                      className="text-decoration-none"
                    >
                      Services
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.chorusaccess.org/news/"
                      target="_blank"
                      className="text-decoration-none"
                    >
                      News
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.chorusaccess.org/events/"
                      target="_blank"
                      className="text-decoration-none"
                    >
                      Events
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.chorusaccess.org/resource-category/general-resources/"
                      target="_blank"
                      className="text-decoration-none"
                    >
                      Resources
                    </a>
                  </li>
                </ul>
              </div>

              {/* Support */}
              <div className="col text-center text-lg-start">
                <h4>Support</h4>
                <ul className="list-unstyled d-flex flex-column gap-2 text-center text-lg-start">
                  <li>
                    <a
                      href="https://www.chorusaccess.org/contact/"
                      target="_blank"
                      className="text-decoration-none"
                    >
                      Contact Us
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.chorusaccess.org/contact/"
                      target="_blank"
                      className="text-decoration-none"
                    >
                      Leave Feedback
                    </a>
                  </li>
                </ul>
              </div>

              {/* Legal */}
              <div className="col text-center text-lg-start">
                <h4>Legal</h4>
                <ul className="list-unstyled d-flex flex-column gap-2 text-center text-lg-start">
                  <li>
                    <a
                      href="https://www.chorusaccess.org/chorus-dashboard-release-notes/"
                      target="_blank"
                      className="text-decoration-none"
                    >
                      Release notes
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.chorusaccess.org/terms-of-use/"
                      target="_blank"
                      className="text-decoration-none"
                    >
                      Terms of Use
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.chorusaccess.org/privacy-policy/"
                      target="_blank"
                      className="text-decoration-none"
                    >
                      Privacy Policy
                    </a>
                  </li>

                  {/* <li>
                    <a
                      href="https://www.windmilldesign.com/portfolio/web-design-and-development-for-chorus"
                      target="_blank"
                      className="text-decoration-none"
                    >
                      Site Credits
                    </a>
                  </li> */}
                </ul>
              </div>
              {/* </div> */}

              {/* CTA */}
              <div className="footer-cta col-12 col-lg-3 px-4">
                <p className="footer-join-text">
                  Add your voice! We invite all organizations, businesses, and
                  institutions involved in scholarly communications to become
                  part of CHORUS.
                </p>
                <a
                  href="https://www.chorusaccess.org/join-chorus/"
                  target="_blank"
                  className="btn btn-outline-primary fw-semibold px-4 py-2"
                >
                  JOIN CHORUS
                </a>
              </div>
            </div>
          </div>

          {/* Copyright */}
          <div className="footer-bottom bg-light text-center">
            <hr />
            <div className="pb-2">
              © {new Date().getFullYear()} CHOR, Inc. All Rights Reserved
            </div>
          </div>
        </footer>
      )}
    </>
  );
};

export default Footer;
